import request, { mobileService } from '@/utils/request';
import { parseImageUrl } from '@/utils/image';

// 广告相关接口
/**
 * 获取广告信息
 * @param {string} advertCode - 广告编号
 * @returns {Promise} 返回广告数据
 */
export function getAdvertisement(advertCode) {
  return request({
    url: '/api/Article/GetArticleByCode',
    method: 'post',
    data: { AdvertCode: advertCode }
  });
}

// 分类相关接口
export function getCategoryTree(params = { TypeId: 7780 }) {
  return request({
    url: '/api/Article/GetTypeTree',
    method: 'post',
    data: params
  });
}

// 其他商品相关接口...
/**
 * 获取商品销量排序列表
 * @param {Object} params
 * @param {number} params.TypeId - 分类ID
 * @param {number} params.PageIndex - 页码，默认1
 * @param {number} params.PageSize - 每页数量，默认10
 * @param {string} params.Code - 分类编码（可选）
 * @returns {Promise} 返回处理后的商品列表数据
 */
export function getProductListOrderbySellCounter(params) {
  return request({
    url: '/api/Product/GetProductListOrderbySellCounter',
    method: 'post',
    data: {
      TypeId: params.TypeId,
      PageIndex: params.PageIndex || 1,
      PageSize: params.PageSize || 10,
      Code: params.Code
    }
  }).then(response => {
    if (response.ErrorCode === 0 && response.Data?.ProductList) {
      return {
        ...response,
        Data: {
          List: response.Data.ProductList.map(product => ({
            id: product.ProductNo,
            name: product.ProductName,
            description: product.ShortDesc || '',
            price: product.SalePrice,
            originalPrice: product.MarketPrice,
            imageUrl: parseImageUrl(product.ProductImage),
            saleCount: product.SaleCount,
            url: product.Url,
            status: product.Status,
            favoriteCount: product.FavoriteCount,
            isLike: product.IsLike
          }))
        }
      }
    }
    throw new Error(response.ErrorMessage || '获取商品列表失败')
  }).catch(error => {
    console.error('获取商品列表失败:', error)
    throw error
  })
}

/**
 * 获取产品搜索结果
 * @param {Object} params
 * @param {string} params.keyword - 搜索关键词
 * @param {number} params.pageIndex - 页码，默认1
 * @param {number} params.pageSize - 每页数量，默认10
 * @returns {Promise} 返回处理后的商品列表数据
 */
export function getProductSearchResult(params = {}) {
  // 构造param参数对象
  const paramObj = {
    PageIndex: params.pageIndex || 1,
    PageSize: params.pageSize || 10,
    Keyword: params.keyword || " ",
    SearchPropList: [],
    CategoryId: "",
    MemberAccount: ""
  };

  // 构造FormData，使用正确的参数格式
  const formData = new URLSearchParams();
  formData.append('key', 'Pub.LoadProductList');
  formData.append('param', JSON.stringify(paramObj));
  formData.append('temp', Date.now());

  return mobileService({
    url: '/Interface/ajax/CommandService.aspx',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    },
    data: formData
  }).then(response => {
    if (response.ErrorCode === '0000' && response.Result?.List) {
      return {
        ...response,
        Result: {
          List: response.Result.List.map(item => ({
            id: item.ProductNo,
            name: item.ProductName,
            description: item.ShortDesc || '',
            imageUrl: parseImageUrl(item.ThumbnailImg),
            price: parseFloat(item.SalePrice) || 0,
            originalPrice: parseFloat(item.MarketPrice) || 0,
            url: `https://m.gdtvdv.com/wap/shop/productdetail.aspx?no=${item.ProductNo}`,
            status: item.Status,
            storage: item.Storage || 0,
            saleCount: item.SellCount || 0,
            isLike: 0,
            favoriteCount: 0
          }))
        }
      }
    }
    throw new Error(response.ErrorMsg || '获取商品列表失败')
  }).catch(error => {
    console.error('获取商品搜索结果失败:', error)
    throw error
  })
} 